<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { applyUpdate, needRefresh } from './pwa'

/**
 * «Доступна новая версия» (ТЗ 18.7): обновление только по кнопке, чтобы не потерять
 * несохранённую форму. «Позже» прячет сообщение до следующего запуска.
 */
const { t } = useI18n()
const busy = ref(false)

async function update(): Promise<void> {
  busy.value = true
  await applyUpdate()
}
</script>

<template>
  <div v-if="needRefresh" class="update" role="status" data-testid="update-banner">
    <i class="pi pi-sparkles update__icon" aria-hidden="true" />
    <span class="update__text">{{ t('pwa.updateReady') }}</span>
    <Button
      :label="t('pwa.later')"
      text
      size="small"
      severity="secondary"
      class="update__later"
      @click="needRefresh = false"
    />
    <Button
      :label="t('pwa.update')"
      size="small"
      :loading="busy"
      data-testid="update-apply"
      @click="update"
    />
  </div>
</template>

<style scoped>
.update {
  position: fixed;
  z-index: 1100;
  left: 50%;
  bottom: calc(5rem + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  width: min(28rem, calc(100vw - 2rem));
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: 12px;
  background: var(--p-surface-800);
  color: var(--p-surface-0);
  box-shadow: 0 6px 24px rgb(0 0 0 / 0.2);
}
@media (min-width: 960px) {
  .update {
    bottom: 1rem;
  }
}
.update__icon {
  color: var(--p-primary-200);
}
.update__text {
  flex: 1;
  min-width: 0;
  font-weight: 600;
}
.update__later.p-button {
  color: var(--p-surface-200);
}
.update :deep(.p-button) {
  min-height: 40px;
}
:root.app-dark .update__icon {
  color: var(--p-primary-color);
}
</style>
